import React from "react";
import { Tabs, Tab } from "@mui/material";
import { ChartNoAxesCombined, ClipboardList, BriefcaseBusiness, Package, CircleUserRound } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { getAllMarketData } from "../services/allApiService";
import { listWatchlist } from "../services/authService";

function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const getTabValue = (path) => {
    switch (path) {
      case "/market": return 0;
      case "/watchlist": return 1;
      case "/portfolio": return 2;
      case "/order": return 3;
      case "/account": return 4;
      default: return 4;
    }
  };

  const [value, setValue] = React.useState(getTabValue(location.pathname));

  const handleChange = async (event, newValue) => {
    if (value === newValue) return;

    const paths = ["/market", "/watchlist", "/portfolio", "/order", "/account"];
    const nextPath = paths[newValue];

    // await preloadData(nextPath);
    setValue(newValue);
    navigate(nextPath);
  };

  // const preloadData = async (path) => {
  //   if (path === "/market" && !sessionStorage.getItem("marketLoaded")) {
  //     if (!localStorage.getItem("marketData")) {
  //       await getAllMarketData("NFO");
  //     }
  //     sessionStorage.setItem("marketLoaded", "true");
  //   } else if (path === "/watchlist" && !sessionStorage.getItem("watchlistLoaded")) {
  //     if (!localStorage.getItem("watchlistData")) {
  //       await listWatchlist();
  //     }
  //     sessionStorage.setItem("watchlistLoaded", "true");
  //   }
  // };
  
  return (
    <div className="fixed bottom-0 w-full max-w-[380px] min-w-[320px] shadow-md bg-white h-[auto]">
      <Tabs
        value={value}
        onChange={handleChange}
        className="bg-white rounded-b-[20px] px-0"
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab
          icon={<ChartNoAxesCombined className="w-4 h-4 mt-0" />}
          label={<span className="text-xs mt-0 capitalize">Market</span>}
          className="font-lato flex flex-col items-center justify-center px-0"
          sx={{
            minWidth: "60px",
            flexGrow: 1,
            textAlign: "center"
          }}
        />
        <Tab
          icon={<ClipboardList className="w-4 h-4 mt-0" />}
          label={<span className="text-xs mt-0 capitalize">Watchlist</span>}
          className="font-lato flex flex-col items-center justify-center px-0"
          sx={{
            minWidth: "60px",
            flexGrow: 1,
            textAlign: "center"
          }}
        />
        <Tab
          icon={<BriefcaseBusiness className="w-4 h-4 mt-0" />}
          label={<span className="text-xs mt-0 capitalize">Portfolio</span>}
          className="font-lato flex flex-col items-center justify-center px-0"
          sx={{
            minWidth: "60px",
            flexGrow: 1,
            textAlign: "center"
          }}
        />
        <Tab
          icon={<Package className="w-4 h-4 mt-0" />}
          label={<span className="text-xs mt-0 capitalize">Order</span>}
          className="font-lato flex flex-col items-center justify-center px-0"
          sx={{
            minWidth: "60px",
            flexGrow: 1,
            textAlign: "center"
          }}
        />
        <Tab
          icon={<CircleUserRound className="w-4 h-4 mt-0" />}
          label={<span className="text-xs mt-0 capitalize">Account</span>}
          className="font-lato flex flex-col items-center justify-center px-0"
          sx={{
            minWidth: "60px",
            flexGrow: 1,
            textAlign: "center"
          }}
        />
      </Tabs>
    </div>
  );
}

export default Footer;